import { useCallback } from "react";
import type { Permission } from "src/api/generated/iam/permissions.ts";
import { useGlobalInitData } from "src/contexts/GlobalInitDataContext.ts";

/**
 * Checks the signed-in user's permissions. The backend sends them with the permissions they include, so an
 * all-records permission such as `customers:read_all` also passes a check for `customers:read`.
 */
export function useHasPermission(): (permission: Permission) => boolean {
	const { userPermissions } = useGlobalInitData();
	return useCallback((permission: Permission) => userPermissions.includes(permission), [userPermissions]);
}
